import { TRANSLATION_UPDATE } from "../actions/TranslationActions";

export default (state = {}, { type, payload }) => {
  switch (type) {
    case TRANSLATION_UPDATE:
      return {
        ...state,
        ...payload
      };
    default:
      return state;
  }
};
